
import { Component, Vue } from "vue-property-decorator";

@Component
export default class MobileLayout extends Vue {}
